import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import React, { useMemo, useState } from "react";
import {
  useDeletePublicReportMutation,
  useGetPublicReportsQuery,
} from "../../services/report.query";
import { DefaultPage } from "../../layouts/default-page";
import { Delete, Preview } from "@mui/icons-material";
import { DataTable } from "../../layouts/data-table";
import { format } from "date-fns";
import DeleteConfirmationDialog from "../../layouts/delete-confirm";
import { useGetDeputyReviewsQuery } from "../../services/deputy-reviews.query";
import { useNavigate } from "react-router-dom";
import { useApproveDeputyUserMutation, useApproveUserMutation, useDeclineUserMutation, useGetDeputyRegisterRequestsQuery } from "../../services/user.query";
import { Notify } from "../../layouts/notify";
// import { PublicReportDetailPanel } from "./public-report-detail-panel";

export default function DeputyRegisterRequest() {
  const [globalFilter, setGlobalFilter] = useState("");
  const [open, setOpen] = React.useState<boolean>(false);
  const handleClose = () => {
    setOpen(false);
  };

  const [openApprove, setOpenApprove] = React.useState<boolean>(false);
  const [itemTOBeApproved, setItemTobeApproved] = React.useState<any>(null);
  const [itemToBeDecline, setItemToBeDecline] = React.useState<any>(null);

  const [declineUser, { isLoading: declining }] = useDeclineUserMutation();
  const [approveUser, { isLoading: approving }] = useApproveUserMutation();

  const handleCloseApprove = () => {
    setOpenApprove(false);
  };

  const openDeleteModal = (row: any) => {
    setOpen(true);
    setItemToBeDecline(row);
  };
  const openApproveModal = (row: any) => {
    setOpenApprove(true);
    setItemTobeApproved(row);
  };

  const declineItem = async () => {
    try {
      await declineUser(itemToBeDecline?.id);

      Notify("info", "Decline Successfully");
      navigate("/hr/user");
      setOpen(false);
    } catch (err) { }
    setOpen(false);
    Notify("error", "error happened while declining");
  };
  // const approveItem = async () => {
  //   try {
  //     await useApproveDeputyUserMutation(itemTOBeApproved?.id);
  //     Notify("info", "Verified Successfully");
  //     setOpenApprove(false);
  //     navigate("/hr/user");
  //   } catch (err) {
  //     setOpenApprove(false);
  //     Notify("error", "Error Happened while Approving");
  //   }
  // };
  const {
    data: DeputyRegisterRequests,
    isLoading,
    isFetching,
    isSuccess,
    isError,
  } = useGetDeputyRegisterRequestsQuery("");
  const columns = [

    {
      accessorKey: "name",
      header: "Deputy Name",
      size: 40,
    },
    {
      accessorKey: "email",
      header: "Deputy Email",
      size: 40,
    },
    {
      accessorKey: "phone_number",
      header: "Phone Number",
      size: 40,
    },
    {
      accessorKey: "created_at",
      header: "Date Requested",
      size: 40,
      Cell: ({ cell }: any) => format(new Date(cell.getValue()), "MMMM dd, yyyy"),
    },

  ];
  // Filtered data using global search across multiple columns
  const filteredData = useMemo(() => {
    if (!globalFilter) return DeputyRegisterRequests; // return all movies if no filter is applied
    return DeputyRegisterRequests?.filter(
      (pr: { email: any; phone_number: any; report: any }) => {
        const searchContent =
          `${pr?.email} ${pr?.phone_number} ${pr?.report}`.toLowerCase();
        return searchContent?.includes(globalFilter.toLowerCase());
      }
    );
  }, [globalFilter, DeputyRegisterRequests]);

  const navigate = useNavigate();

  const viewReview = (rowData: any) => {
    navigate("/deputies/details", { state: { deputyReview: rowData } });
  };

  return (
    <DefaultPage title="Deputy Register Requests" loading={isLoading}>
      <DataTable
        count={DeputyRegisterRequests?.length}
        columns={columns}
        globalFilter={setGlobalFilter}
        list={filteredData as any}
        getRowId={(row: { id: any }) => row.id}
        isLoading={isLoading}
        isSuccess={isSuccess}
        toolbar={true}
        toolbarActions={true}
        isFetching={isFetching}
        enableBottomToolbar={true}
        enablePinning={true}
        isError={isError}
        toolbarActionMargin="2"
        // renderDetailPanel={({ row }: any) => {
        //   return <PublicReportDetailPanel report={row.original} />;
        // }}
        renderRowActions={({ row }: any) => (
          <Box sx={{ display: "flex" }}>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                color="success"
                variant="contained"
                onClick={() => openApproveModal(row?.original)}
              >
                Approve
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => openDeleteModal(row?.original)}
              >
                Decline
              </Button>
            </Box>

          </Box>
        )}
      />
      <DeleteConfirmationDialog
        open={open}
        onClose={handleClose}
        onConfirm={declineItem}
        loading={declining}
        confirmMessage="Are You Sure to Decline ?"
        item={itemToBeDecline?.name}
        itemName={itemToBeDecline?.email}
      />
      <DeleteConfirmationDialog
        open={openApprove}
        onClose={handleCloseApprove}
        onConfirm={declineItem}
        loading={approving}
        confirmMessage="Are You Sure to Approve?"
        item={itemTOBeApproved?.email}
        itemName={itemTOBeApproved?.email}
      />
    </DefaultPage>
  );
}
